import styles from "./Generic.module.css";
import { FC } from "react";
type Props = {
  children: string;
  color?: string;
  size?: number;
};

export const SmallText: FC<Props> = ({ children, color, size }) => {
  return (
    <p
      className={styles.smallText}
      style={{ color: `${color}`, fontSize: size ? `${size}px` : "10px" }}
    >
      {children}
    </p>
  );
};
